import { Button } from '@/uicomponents';
import { PageTitle } from '@/lib/hooks';
import { ErrorPanel } from '../state-panel';
import { PageContainer } from '../page-container';

interface ServerUnreachableProps {
  onRetry: () => void;
  retrying: boolean;
}

/**
 * Shown when the session check got no answer from the server (NPJB-815): a timeout or a
 * gateway 5xx. The session may be fine, so this is not a trip to /login. The URL stays put,
 * so a retry that succeeds lands on the page the link asked for.
 */
export const ServerUnreachable = ({ onRetry, retrying }: ServerUnreachableProps) => (
  <PageContainer maxWidth='md'>
    <PageTitle title='Cannot Reach 3rd Eye' />
    <ErrorPanel
      title='We cannot reach 3rd Eye right now'
      actions={
        <Button onClick={onRetry} loading={retrying}>
          Try Again
        </Button>
      }
    >
      The server did not answer. Try again in a moment. You will land on the page you opened.
    </ErrorPanel>
  </PageContainer>
);
